import {ApplicationState} from "../reducers";
import {ThunkAction} from "redux-thunk";
import {apiDelete, apiError, apiPost, apiPut, apiRequest, CommonAction} from "./common";
import {DiscountCode} from "../models/order";

export const DISCOUNTS_LOADING = "DISCOUNTS_LOADING";
export const DISCOUNTS_LOADED = "DISCOUNTS_LOADED";
export const DISCOUNTS_API_ERROR = "DISCOUNTS_API_ERROR";
export const DISCOUNTS_UPDATE_NEW = "DISCOUNTS_UPDATE_NEW";
export const DISCOUNTS_SAVE_LOADING = "DISCOUNTS_SAVE_LOADING";
export const DISCOUNTS_SAVED = "DISCOUNTS_SAVED";
export const DISCOUNTS_UPDATED = "DISCOUNTS_UPDATED";
export const DISCOUNTS_DELETED = "DISCOUNTS_DELETED";

type DiscountActionResponse = ThunkAction<Promise<DiscountsAction>, ApplicationState, {}>;

export interface DiscountsAction extends CommonAction {
    loading?: boolean;
    discounts?: DiscountCode[];
    newDiscount?: DiscountCode;
}

export const getDiscountList = (): DiscountActionResponse => dispatch => {
    dispatch({type: DISCOUNTS_LOADING});
    return apiRequest<DiscountCode[]>(`/discounts`)
        .then(response => {
            return dispatch({
                type: DISCOUNTS_LOADED,
                discounts: response
            }) as DiscountsAction;
        })
        .catch(err => dispatch(apiError(DISCOUNTS_API_ERROR, err)));
};

export const updateNewDiscount = (discount: DiscountCode): DiscountsAction => ({
    type: DISCOUNTS_UPDATE_NEW, newDiscount: discount
});

export const saveNewDiscount = (discount: DiscountCode): DiscountActionResponse => dispatch => {
    dispatch({type: DISCOUNTS_SAVE_LOADING});
    return apiPost<DiscountCode>(`/discounts`, discount)
        .then(response => {
            return dispatch({
                type: DISCOUNTS_SAVED,
                newDiscount: response
            }) as DiscountsAction;
        })
        .catch(err => dispatch(apiError(DISCOUNTS_API_ERROR, err)));
};

export const updateDiscount = (discount: DiscountCode): DiscountActionResponse => dispatch => {
    dispatch({type: DISCOUNTS_SAVE_LOADING});
    return apiPut<DiscountCode>(`/discounts/${discount.id}`, discount)
        .then(response => {
            return dispatch({
                type: DISCOUNTS_UPDATED,
                newDiscount: response
            }) as DiscountsAction;
        })
        .catch(err => dispatch(apiError(DISCOUNTS_API_ERROR, err)));
};

export const deleteDiscount = (discount: DiscountCode): DiscountActionResponse => dispatch => {
    dispatch({type: DISCOUNTS_SAVE_LOADING});
    return apiDelete<DiscountCode>(`/discounts/${discount.id}`)
        .then(response => {
            return dispatch({
                type: DISCOUNTS_DELETED,
                newDiscount: discount
            }) as DiscountsAction;
        })
        .catch(err => dispatch(apiError(DISCOUNTS_API_ERROR, err)));
};



// WEBPACK FOOTER //
// ./src/actions/discounts.ts